/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TermsAndCondition = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        title: {
    type: 'string',
    isRequired: true,
},
        description: {
    type: 'string',
    isRequired: true,
},
    },
};